import global from '@/mixins/global';
import { MetaRoles, Roles } from '@/core/constants/roleConstants';

/**
 * Resolve role-specific stored username information.
 * Returns an object with `username` and `metaRole` when available.
 */
export function roleResolver(role = '') {
  const roleResolvers = {
    [MetaRoles.Seller]: {
      username: global.methods.$getLocalStorageSeller(),
      metaRole: MetaRoles.Seller,
      role: Roles.SELLER,
    },
    [MetaRoles.Manager]: {
      username: global.methods.$getLocalStorageManager(),
      metaRole: MetaRoles.Manager,
      role: Roles.MANAGER,
    },
    [MetaRoles.RegionalManager]: {
      username: global.methods.$getLocalStorageRegional(),
      metaRole: MetaRoles.RegionalManager,
      role: Roles.REGIONAL_MANAGER,
    },
    [MetaRoles.Director]: {
      username: global.methods.$getLocalStorageDirector(),
      metaRole: MetaRoles.Director,
      role: Roles.DIRECTOR,
    },
  };
  return roleResolvers[role] ?? '';
}

export default roleResolver;
